import { useContext } from "react";
import { GlobalContext } from "../../context/GlobalContext";

const Menu = ({ handleClick, width = "50px", height = "50px" }) => {
  const { menuClicked, setMenuClicked } = useContext(GlobalContext);

  const onMenuClick = () => {
    setMenuClicked(!menuClicked);
    handleClick();
  };

  return (
    <img
      className="pointer"
      color="white"
      src={require("../../assets/icons/documents.svg").default}
      alt="documents"
      width={width}
      height={height}
      onClick={onMenuClick}
      style={{ objectFit: "contain" }}
    />
  );
};

export default Menu;
